import { dataHammerSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHammerSolid = /*#__PURE__*/createIcon(dataHammerSolid)
export default IconHammerSolid
